import { useAgentEditorStore } from '@/state/root';
import theme from '@/theme';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { AGENT_DEFAULT_NAME } from '../../../../constants';
import { CharCounterContainer, MultiLineInput } from '../common';

export const defaultAgentGreetingV2 = (agentName: string) =>
    `Hi! I'm ${agentName !== '' ? agentName : AGENT_DEFAULT_NAME}. How can I help you?`;

const GreetingInput = styled(MultiLineInput)`
    textarea {
        height: 72px !important;
    }

    .Mui-focused.Mui-error {
        background-color: ${theme.colors.error.bgLight};
    }
`;

const CHAR_LIMIT = 350;
const INPUT_PROPS = {
    maxLength: CHAR_LIMIT,
};

const CustomGreeting = observer(() => {
    const agentEditorStore = useAgentEditorStore();
    const defaultGreeting = defaultAgentGreetingV2(agentEditorStore.inputAgent.preview_name || AGENT_DEFAULT_NAME);

    const onInputChange: React.ChangeEventHandler<HTMLTextAreaElement> = e => {
        const value = e.target.value;
        agentEditorStore.setGreetings([value]);
    };

    const greeting = agentEditorStore.greetings[0];

    return (
        <GreetingInput
            multiline
            value={greeting}
            placeholder={defaultGreeting}
            onChange={onInputChange}
            inputProps={INPUT_PROPS}
            helperText={
                <CharCounterContainer>
                    {greeting?.length ?? 0}/{CHAR_LIMIT}
                </CharCounterContainer>
            }
        />
    );
});

export default CustomGreeting;
